import { v2Host } from '@/config/host'

export const resStoreDownloadUrl = `${v2Host}/res_store/download`

export const logoutUrl = `${v2Host}/logout`

export const loginUrl = `${v2Host}/login`
